export var beepOk: string;
export var beepFail: string;
export var enter: string;
export var exit: string;

let sound: HTMLAudioElement;

export async function playSoundAsync(src: string) {

    console.debug("sound START");

    try {

        if (!sound)
            sound = new Audio();
        sound.volume = 1;
        sound.loop = false;
        sound.autoplay = false;
        sound.preload = "auto";

        await new Promise<void>(res => {
            sound.src = "";
            sound.src = src;
            sound.onloadedmetadata = () => res();
        });

        console.debug("sound LOAD");

        await new Promise<void>(async res => {
            sound.onended = () => res();
            if (!sound.paused)
                sound.pause();
            sound.play();
        });

    }
    catch (ex) {

        console.error(ex);
    }

    console.debug("sound END");
}

export async function vibrate(success: boolean) {
    if ("vibrate" in navigator) {
        console.debug("vibrate START");
        if (success)
            navigator.vibrate(200);
        else
            navigator.vibrate([100, 50, 100, 50, 100]);
        console.debug("vibrate END");
    }
}

export async function preloadAsync() {
    beepOk = URL.createObjectURL(await (await fetch("/assets/BeepOk.wav")).blob());
    beepFail = URL.createObjectURL(await (await fetch("/assets/BeepFail.wav")).blob());
    enter = URL.createObjectURL(await (await fetch("/assets/Enter.mp3")).blob());
    exit = URL.createObjectURL(await (await fetch("/assets/Exit.mp3")).blob());
}